import { render, staticRenderFns } from "./invite-detail.vue?vue&type=template&id=cb4483d6&scoped=true"
import script from "./invite-detail.vue?vue&type=script&lang=js"
export * from "./invite-detail.vue?vue&type=script&lang=js"
import style0 from "./invite-detail.vue?vue&type=style&index=0&id=cb4483d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4483d6",
  null
  
)

export default component.exports